import { Component, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsService } from '../../../services/icons.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MenuService } from '../../../services/menu.service';
import { environment } from '../../../../environments/environment';
import { MenuItem } from '../../../interface/data-core';
import { AuthService } from '../../../auth/services/auth.service';

// Interfaces para definir la estructura del menú

@Component({
    selector: 'app-header-krismar',
    imports: [CommonModule],
    templateUrl: './header-krismar.component.html',
    styleUrl: './header-krismar.component.css'
})
export class HeaderKrismarComponent {
    public _icon = inject(IconsService);
    public _sanitizer = inject(DomSanitizer)
    public _menu = inject(MenuService);
    public _auth = inject(AuthService);

    public loggedIn = this._auth.isAuthenticated();

    public icon_clock = `${this._icon.clock}${"Lo más reciente"}`;

    // Propiedad pública para usar en el template
    public menuItems: MenuItem[] = [];

    constructor() {
        effect(() => {
            this.loggedIn = this._auth.isAuthenticated();
        });
        // Inicializar los menús al crear el componente
        this.getMenuConfiguration();
    }
    /**
        * @description: Configuración predefinida de menús
        * @returns Array con la configuración completa de menús
        */
    getMenuConfiguration() {
        let tipoMenu: string = environment.portal;
        this.menuItems = this._menu.getMenuByPortal(tipoMenu);
    }



    /**
     * @description: Abre menu en header
     */
    public openMenu(): void {
        const headerElement = document.querySelector("#d_header");
        if (headerElement) {
            headerElement.classList.add('d_headeropenmenu');
        }
    }


    public closeMenu(): void {
        const headerElement = document.querySelector("#d_header");
        if (headerElement) {
            headerElement.classList.remove('d_headeropenmenu');
        }
    }

    /**
     * @description: Abre los submenu
     * @param event Evento click del botón que abre el submenu
     */
    public openSubmenu(event: Event): void {

        const getThis = event.currentTarget as HTMLElement;
        const headerMenu = document.querySelector('#d_headermenu');
        if (!headerMenu) return;

        const headerMenuUls = headerMenu.querySelectorAll('ul');
        const headerMenuDivs = headerMenu.querySelectorAll('div');

        headerMenuUls.forEach((ul) => {
            (ul as HTMLElement).style.display = 'none';
        });

        headerMenuDivs.forEach((div) => {
            div.classList.remove('d_addactive');
        });

        const parent = getThis.parentElement;
        if (!parent) return;

        const submenu = parent.querySelector('ul') as HTMLElement;
        if (submenu) {
            submenu.style.display = submenu.style.display === 'flex' ? 'none' : 'flex';
        }
        getThis.classList.add('d_addactive');
    }

    openOverlaylogin(): void {

        if (environment.offline) {

            this._auth.loginOffline();
            return;
        }
        this._auth.visible_login = true;
    }

    onLogout(): void {
        this._auth.logout();
    }


}
